/* Find Deals screen */
import React, { Component, Suspense } from "react";
import axios from "../../axios";
import { isPossiblePhoneNumber } from "react-phone-number-input";
import "../../brands/common/css/common.scss";
import Footer from "../../components/Common/Footer";
import {
} from "mdbreact";
let VerificationComponent = React.lazy(() =>
    import(
        "../../brands/" +
            sessionStorage.getItem("customBrand") +
            "/components/CreateAccount/Verification"
    )
);
let Logo;
let BrandName;
let supportPhoneNumber;

class Verification extends Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNumber: sessionStorage.getItem("phoneNumber"),
            enterVerification: false,
            errorMessage: undefined,
            verifyingPhoneNumber: false,
        };
        this._reCaptchaRef = React.createRef();
    }
    sendSMSCode = (event) => {
        this.setState({
            smsCode: event.target.value,
        });
        let data;
        if (event.target.value.length === 4) {
            this.setState({
                verifyingPhoneNumber: true,
            });
            data = sessionStorage.getItem("clientSecret")
                ? {
                      StripeClientSecret:
                          sessionStorage.getItem("clientSecret"),
                      "PhoneNumber.E164":
                          sessionStorage.getItem("phoneNumber"),
                      SMSOTP: parseInt(event.target.value),
                  }
                : {
                      SetupIntentId: sessionStorage.getItem("setupIntentId"),
                      "PhoneNumber.E164":
                          sessionStorage.getItem("phoneNumber"),
                      SMSOTP: parseInt(event.target.value),
                  };
            axios
                .post(
                    "/networkoperatorconsole/shoppingcart/verifyPhoneNumber",
                    data,
                    {
                        headers: { "api-version": "20260417" },
                    }
                )
                .then((response) => {
                    this.setState({
                        verifyingPhoneNumber: false,
                    });
                    document.location.href = "/paymentsuccess";
                })
                .catch((error) => {
                    this.setState({
                        verifyingPhoneNumber: false,
                    });
                    this.setState({
                        smsErrorMessage:
                            "The code you entered does not match our records. Please re-enter the code.",
                    });
                });
        } else {
            this.setState({
                smsErrorMessage: undefined,
            });
        }
    };
    changeHandlerPhone = (event) => {
        this.setState({ phoneNumber: event });
        var value = event
            ? isPossiblePhoneNumber(event)
                ? undefined
                : "Please provide a valid phone number"
            : "Phone number required";
        this.setState({ invalidPhone: value });
        sessionStorage.setItem("phoneNumber", event);
    };
    textCode = (event) => {
        event.preventDefault();
        let BillingCycleRecurrence;
        !sessionStorage.getItem("daysofservice")
            ? (BillingCycleRecurrence = 0)
            : (BillingCycleRecurrence =
                  sessionStorage.getItem("daysofservice"));
        let data = {
            VenueID: sessionStorage.getItem("venueID"),
            ServicePlanID: sessionStorage.getItem("servicePlanID"),
            UnitID_internal: sessionStorage.getItem("unit"),
            EmailAddress: sessionStorage.getItem("email"),
            GivenName: sessionStorage.getItem("firstName"),
            FamilyName: sessionStorage.getItem("lastName"),
            "PhoneNumber.E164": sessionStorage.getItem("phoneNumber"),
            locale: "en-us",
            contactpref_sms: sessionStorage.getItem("sms"),
            "StartDateTimeUTC.ISO8601": new Date(
                sessionStorage.getItem("dateStart")
            ).toISOString(),
            BillingCycleRecurrence: BillingCycleRecurrence,
        };
        axios
            .post(
                "/networkoperatorconsole/shoppingcart/requestSubscription",
                data,
                {
                    headers: { "api-version": "20260417" },
                }
            )
            .then((response) => {
                if (response.data.phone_number_verified) {
                    document.location.href = "/paymentsuccess";
                } else {
                    this.setState({
                        enterVerification: true,
                        smsCode: "",
                        smsErrorMessage: undefined,
                    });
                    if (response.data.StripeClientSecret === undefined) {
                        sessionStorage.setItem(
                            "setupIntentId",
                            response.data.SetupIntentId
                        );
                    } else {
                        sessionStorage.setItem(
                            "clientSecret",
                            response.data.StripeClientSecret
                        );
                    }
                }
            })
            .catch((error) => {
                this.setState({
                    errorMessage: error.response.data.message,
                    smsCode: "",
                    smsErrorMessage: undefined,
                    enterVerification: false,
                });
            });
    };
    toggle = () => {
        this.setState({
            enterVerification: !this.state.enterVerification,
        });
    };
    onChange(value) {
     console.log("Captcha value:", value);
   }
   onChangeInvisible(value) {
    // event.preventDefault();
    this._reCaptchaRef.current.execute().then(value => {
     console.log("executeAsync promise - Captcha value:", value);
   });
    // console.log("Captcha value invisible:", value);
  }
  onSubmit = () => {
   this._reCaptchaRef.current.execute();
 };
 onSubmitAsync = () => {
  this._reCaptchaRef.current.executeAsync().then(value => {
    console.log("executeAsync promise - Captcha value:", value);

  // this.requestSubscription();
  });
};
handleChange = value => {

 // this.requestSubscription();
 console.log("onChange prop - Captcha value:", value);
 this.setState({ value });
 if (value === null) this.setState({ expired: "true" });
};

asyncScriptOnLoad = () => {
 this.setState({ callback: "called!", recaptchaLoaded: true });
 console.log("scriptLoad - reCaptcha Ref-", this._reCaptchaRef);
};
requestSubscription = () => {
 // event.preventDefault();
 let BillingCycleRecurrence;
 !sessionStorage.getItem("daysofservice")
     ? (BillingCycleRecurrence = 0)
     : (BillingCycleRecurrence =
           sessionStorage.getItem("daysofservice"));
 let data = {
     VenueID: sessionStorage.getItem("venueID"),
     ServicePlanID: sessionStorage.getItem("servicePlanID"),
     UnitID_internal: sessionStorage.getItem("unit"),
     EmailAddress: sessionStorage.getItem("email"),
     GivenName: sessionStorage.getItem("firstName"),
     FamilyName: sessionStorage.getItem("lastName"),
     "PhoneNumber.E164": sessionStorage.getItem("phoneNumber"),
     locale: "en-us",
     contactpref_sms: sessionStorage.getItem("sms"),
     "StartDateTimeUTC.ISO8601": new Date(
         sessionStorage.getItem("dateStart")
     ).toISOString(),
     BillingCycleRecurrence: BillingCycleRecurrence,
 };
 console.log(data)
 axios
     .post(
         "/networkoperatorconsole/shoppingcart/requestSubscription",
         data,
         {
             headers: { "api-version": "20260417" },
         }
     )
     .then((response) => {
             document.location.href = "/paymentsuccess";
         
     })
     .catch((error) => {
         this.setState({
             errorMessage: error.response.data.message,
             smsCode: "",
             smsErrorMessage: undefined,
             enterVerification: false,
         });
     });
};
    render() {
        return (
            <>
                {this.state.errorMessage !== undefined ? (
                    <div className="overlay" style={{ display: "block" }}>
                        <div className="overlayMessage">
                            {this.state.errorMessage}
                            <div className="nextButton">
                                <br />
                                <a
                                    className="btn Ripple-parent btn-default"
                                    href="/"
                                    rel="noreferrer"
                                    onClick={this.handleAnchorClick}
                                >
                                    Return to Login
                                </a>
                            </div>
                        </div>
                    </div>
                ) : (
                    ""
                )}
                <Suspense
                    fallback={
                        <div
                            className="overlay"
                            id="overlay"
                            style={{ display: "block" }}
                        >
                            <div className="overlayMessage">
                                <div
                                    className="spinner-border spinner-border"
                                    role="status"
                                >
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        </div>
                    }
                >
                 {/* <button onClick={this.onSubmit}>
          Submit (with onChange prop)
        </button>
  <button onClick={this.onSubmitAsync}>
          Submit (with executeAsync promise)
        </button> */}
                    <VerificationComponent
                        changeHandlerPhone={this.changeHandlerPhone}
                        textCode={this.textCode}
                        enterVerification={this.state.enterVerification}
                        sendSMSCode={this.sendSMSCode}
                        smsCode={this.state.smsCode}
                        smsErrorMessage={this.state.smsErrorMessage}
                        toggle={this.toggle}
                        logo={this.props.logoLogin}
                        brand={BrandName}
                        supportPhoneNumber={supportPhoneNumber}
                        errorMessage={this.state.errorMessage}
                        verifyingPhoneNumber={this.state.verifyingPhoneNumber}
                        onChange={this.handleChange}
            asyncScriptOnLoad={this.asyncScriptOnLoad}
            onSubmit={this.onSubmit}
            onSubmitAsync={this.onSubmitAsync}
            requestSubscription={this.requestSubscription}
                    />
                    
  {/* <ReCAPTCHA
            style={{ display: "inline-block" }}
            theme="dark"
            size="invisible"
            ref={this._reCaptchaRef}
            sitekey="6LdqBMgqAAAAAAGSKl2OxHFkgZwxtsE469JwR5PP"
            onChange={this.handleChange}
            asyncScriptOnLoad={this.asyncScriptOnLoad}
          /> */}
  
                    <Footer />
                </Suspense>
            </>
        );
    }
}
export default Verification;
